document.addEventListener("DOMContentLoaded", () => {
  // --- Global State ---
  const mouse = { x: 0.5, y: 0.5, px: window.innerWidth / 2, py: window.innerHeight / 2 };
  const smoothMouse = { x: 0.5, y: 0.5, px: window.innerWidth / 2, py: window.innerHeight / 2 };
  const LERP_FACTOR = 0.1; // Smoothing factor (0.1 = smooth, 1.0 = instant)

  window.addEventListener("mousemove", (e) => {
    mouse.px = e.clientX;
    mouse.py = e.clientY;
    mouse.x = e.clientX / window.innerWidth;
    mouse.y = e.clientY / window.innerHeight;
  });

  // --- Background Canvas Animation ---
  const canvas = document.getElementById('bg-canvas');
  if (canvas) {
    const ctx = canvas.getContext('2d');
    let width, height, particles;

    const init = () => {
      width = canvas.width = window.innerWidth;
      height = canvas.height = window.innerHeight;
      particles = [];
      const particleCount = Math.floor((width * height) / 15000);
      
      for (let i = 0; i < particleCount; i++) {
        particles.push({
          x: Math.random() * width,
          y: Math.random() * height,
          vx: (Math.random() - 0.5) * 0.5,
          vy: (Math.random() - 0.5) * 0.5,
          size: Math.random() * 2 + 1
        });
      }
    };

    const animate = () => {
      ctx.clearRect(0, 0, width, height);
      ctx.fillStyle = 'rgba(84, 156, 228, 0.4)';
      ctx.strokeStyle = 'rgba(84, 156, 228, 0.15)';
      
      particles.forEach((p, i) => {
        p.x += p.vx;
        p.y += p.vy;

        if (p.x < 0) p.x = width;
        if (p.x > width) p.x = 0;
        if (p.y < 0) p.y = height;
        if (p.y > height) p.y = 0;

        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fill();

        for (let j = i + 1; j < particles.length; j++) {
          const p2 = particles[j];
          const dx = p.x - p2.x;
          const dy = p.y - p2.y;
          const dist = Math.sqrt(dx * dx + dy * dy);

          if (dist < 150) {
            ctx.beginPath();
            ctx.moveTo(p.x, p.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
          }
        }
      });
      requestAnimationFrame(animate);
    };

    window.addEventListener('resize', init);
    init();
    animate();
  }

  // --- GSAP Parallax & Global Animations ---
  if (typeof gsap !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);

    // Smooth Scroll to #links
    document.querySelectorAll('.js-scroll-link').forEach(link => {
      link.addEventListener('click', (e) => {
        const targetId = link.getAttribute('href');
        if (targetId.startsWith('#')) {
          e.preventDefault();
          const target = document.querySelector(targetId);
          if (target) {
            gsap.to(window, {
              duration: 1.8,
              scrollTo: {
                y: target,
                offsetY: 80
              },
              ease: "power2.out"
            });
          }
        }
      });
    });

    // Parallax for floating elements
    document.querySelectorAll('.floating-el').forEach((el, i) => {
      const speed = 50 + (i % 3) * 30;
      gsap.to(el, {
        y: speed,
        ease: "none",
        scrollTrigger: {
          trigger: el,
          start: "top bottom",
          end: "bottom top",
          scrub: true
        }
      });
    });

    // Subtle parallax for info boxes
    document.querySelectorAll('.info-box').forEach((el) => {
      gsap.to(el, {
        y: -30,
        ease: "none",
        scrollTrigger: {
          trigger: el,
          start: "top bottom",
          end: "bottom top",
          scrub: true
        }
      });
    });

    // Reveal headers
    document.querySelectorAll('.section-header').forEach((header) => {
      gsap.from(header, {
        opacity: 0,
        y: 30,
        duration: 1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: header,
          start: "top 85%",
          toggleActions: "play none none none"
        }
      });
    });

    // Hero Mouse Parallax
    const heroSection = document.querySelector('.hero');
    const heroShape1 = document.querySelector('.hero-bg-shape-1');
    const heroShape2 = document.querySelector('.hero-bg-shape-2');

    if (heroSection && (heroShape1 || heroShape2)) {
      heroSection.addEventListener('mousemove', (e) => {
        const { clientX, clientY } = e;
        const xPos = (clientX / window.innerWidth) - 0.5;
        const yPos = (clientY / window.innerHeight) - 0.5;

        if (heroShape1) {
          gsap.to(heroShape1, {
            x: xPos * 40,
            y: yPos * 40,
            duration: 1.5,
            ease: "power2.out"
          });
        }
        if (heroShape2) {
          gsap.to(heroShape2, {
            x: xPos * -30,
            y: yPos * -30,
            duration: 1.5,
            ease: "power2.out"
          });
        }
      });
    }
  }

  // --- Counter Animation ---
  const counters = document.querySelectorAll(".js-count");
  const countObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const targetValue = el.getAttribute("data-target");
          const target = parseFloat(targetValue.replace(/,/g, ""));
          const duration = 2000;
          const startTime = performance.now();

          const animate = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const easeProgress = 1 - Math.pow(1 - progress, 3);
            const currentCount = easeProgress * target;

            if (targetValue.includes(".")) {
              el.innerText = currentCount.toFixed(1);
            } else {
              el.innerText = Math.floor(currentCount).toLocaleString();
            }

            if (progress < 1) {
              requestAnimationFrame(animate);
            } else {
              el.innerText = targetValue;
            }
          };

          requestAnimationFrame(animate);
          countObserver.unobserve(el);
        }
      });
    },
    { threshold: 0.1 },
  );

  counters.forEach((counter) => countObserver.observe(counter));

  // --- Reveal Animation ---
  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 },
  );

  document.querySelectorAll(".reveal").forEach((el) => revealObserver.observe(el));
  document.querySelectorAll(".hero-reveal").forEach((el) => {
    setTimeout(() => {
      el.classList.add("is-visible");
    }, 100);
  });

  // --- Mobile Menu ---
  const navToggle = document.querySelector(".js-nav-toggle");
  const navMenu = document.querySelector(".nav-menu");
  const nav = document.querySelector(".nav");

  if (navToggle && navMenu) {
    navToggle.addEventListener("click", () => {
      navMenu.classList.toggle("is-active");
      nav.classList.toggle("is-menu-open");
      document.body.classList.toggle("locked");
    });

    // Close menu on link click
    const menuLinks = navMenu.querySelectorAll("a");
    menuLinks.forEach((link) => {
      link.addEventListener("click", () => {
        navMenu.classList.remove("is-active");
        nav.classList.remove("is-menu-open");
        document.body.classList.remove("locked");
      });
    });
  }

  // --- Showcase Interpolated State ---
  const abRows = document.querySelectorAll(".js-ab-row");
  const rowStates = Array.from(abRows).map((row) => ({
    el: row,
    currentSplit: 0,
    targetSplit: 0,
    currentProgress: 0,
    targetProgress: 0,
  }));

  const mainTick = () => {
    // 1. Smooth Mouse
    smoothMouse.x += (mouse.x - smoothMouse.x) * LERP_FACTOR;
    smoothMouse.y += (mouse.y - smoothMouse.y) * LERP_FACTOR;
    smoothMouse.px += (mouse.px - smoothMouse.px) * LERP_FACTOR;
    smoothMouse.py += (mouse.py - smoothMouse.py) * LERP_FACTOR;

    // 3. Showcase Updates
    const vh = window.innerHeight;
    rowStates.forEach((state) => {
      const rect = state.el.getBoundingClientRect();
      const start = vh;
      const end = -rect.height;

      state.targetProgress = Math.max(0, Math.min(1, (start - rect.top) / (start - end)));
      state.currentProgress += (state.targetProgress - state.currentProgress) * LERP_FACTOR;

      let split = 0;
      const p = state.currentProgress;
      if (p < 0.25) split = 0;
      else if (p < 0.55) split = (p - 0.25) / 0.3;
      else if (p < 0.8) split = 1;
      else split = Math.max(0, 1 - (p - 0.8) / 0.2);

      const inX = mouse.px >= rect.left - 100 && mouse.px <= rect.right + 100;
      const inY = mouse.py >= rect.top - 120 && mouse.py <= rect.bottom + 120;
      if (inX && inY) {
        const relX = (mouse.px - rect.left) / rect.width;
        const centerProx = 1 - Math.abs(relX - 0.5) * 2;
        split = Math.min(1, split + centerProx * 0.3);
      }

      state.targetSplit = split;
      state.currentSplit += (state.targetSplit - state.currentSplit) * LERP_FACTOR;

      const card = state.el.querySelector(".js-ab-card");
      const halfA = state.el.querySelector(".js-ab-a");
      const halfB = state.el.querySelector(".js-ab-b");
      const halfC = state.el.querySelector(".js-ab-c");
      const crease = state.el.querySelector(".js-ab-crease");

      const s = state.currentSplit;
      const yOffset = (0.5 - Math.min(state.currentProgress, 0.5)) * 30;
      const cardOpacity = Math.max(0.45, Math.min(1, state.currentProgress * 3));

      if (card) {
        card.style.transform = `translateY(${yOffset}px)`;
        card.style.opacity = cardOpacity;
      }
      const isMobile = window.innerWidth < 960;

      if (halfA) halfA.style.transform = isMobile ? "" : `translateX(${-s * 100}%)`;
      if (halfB) halfB.style.transform = isMobile ? "" : `translateX(${s * 100}%)`;
      if (halfC) {
        halfC.style.opacity = isMobile ? 0 : Math.max(0, s * 1.15 - 0.08);
        halfC.style.transform = isMobile ? "" : `translate(-50%, -50%) scale(${0.85 + s * 0.15})`;
      }
      if (crease) crease.style.opacity = isMobile ? 0 : Math.max(0, 1 - s * 1.3);
    });

    requestAnimationFrame(mainTick);
  };

  requestAnimationFrame(mainTick);

  // --- Popup Logic ---
  const popupTriggers = document.querySelectorAll(".js-open-popup");
  const popups = document.querySelectorAll(".popup-stage");

  const openPopup = (id) => {
    const popup = document.getElementById(id);
    if (popup) {
      popup.classList.add("is-active");
      document.body.classList.add("locked");
      const firstInput = popup.querySelector("input, textarea");
      if (firstInput) setTimeout(() => firstInput.focus(), 600);
    }
  };

  const closePopup = (popup) => {
    popup.classList.remove("is-active");
    // Only unlock if mobile menu isn't also open
    if (!document.querySelector(".nav-menu.is-active")) {
      document.body.classList.remove("locked");
    }
  };

  popupTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      const target = trigger.getAttribute("data-target");
      openPopup(target);
    });
  });

  popups.forEach((popup) => {
    const closeBtn = popup.querySelector(".popup-modal__close");
    const backdrop = popup.querySelector(".popup-backdrop");
    const form = popup.querySelector("form");
    const modal = popup.querySelector(".popup-modal");

    if (closeBtn) closeBtn.addEventListener("click", () => closePopup(popup));
    if (backdrop) backdrop.addEventListener("click", () => closePopup(popup));

    // Success state
    if (form) {
      form.addEventListener("submit", (e) => {
        // Only if it's the static form, CF7 has its own events
        if (!form.classList.contains("wpcf7-form")) {
          e.preventDefault();
          const data = Object.fromEntries(new FormData(form).entries());
          console.log("Form submitted:", data);
          modal.classList.add("is-success");
        }
      });
    }

    // CF7 specific success event
    document.addEventListener(
      "wpcf7mailsent",
      (e) => {
        const formId = e.detail.contactFormId;
        // You could check for specific form ID if needed
        if (popup.contains(e.target)) {
          modal.classList.add("is-success");
        }
      },
      false,
    );

    // Interactive elements for custom cursor
    const interactive = popup.querySelectorAll("a, button, input, textarea, .btn");
    interactive.forEach((el) => {
      el.addEventListener("mouseenter", () => cursor?.classList.add("is-hovering"));
      el.addEventListener("mouseleave", () => cursor?.classList.remove("is-hovering"));
    });
  });

  // Esc key to close all popups
  window.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      popups.forEach((popup) => {
        if (popup.classList.contains("is-active")) closePopup(popup);
      });
    }
  });

  // --- Lottie Animation ---
  const heroVisual = document.querySelector(".hero-visual");
  const lottieContainer = document.getElementById("hero-lottie");

  if (heroVisual && lottieContainer && typeof lottie !== "undefined") {
    const animationPath = heroVisual.getAttribute("data-animation-path");

    lottie.loadAnimation({
      container: lottieContainer,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: animationPath,
    });
  }

  // --- FAQ Accordion ---
  const faqItems = document.querySelectorAll(".js-faq-item");
  faqItems.forEach(item => {
    const header = item.querySelector(".faq-header");
    header.addEventListener("click", () => {
      const isActive = item.classList.contains("is-active");
      
      // Close other items
      faqItems.forEach(otherItem => {
        if (otherItem !== item) {
          otherItem.classList.remove("is-active");
        }
      });

      // Toggle current
      item.classList.toggle("is-active", !isActive);
    });
  });

  // --- Contact Form ---
  const contactForm = document.querySelector(".contact-form");
  if (contactForm) {
    contactForm.addEventListener("submit", (e) => {
      if (!contactForm.classList.contains("wpcf7-form")) {
        e.preventDefault();
        const data = Object.fromEntries(new FormData(contactForm).entries());
        console.log("Contact form submitted:", data);
        
        // Show success state
        const wrapper = contactForm.closest(".contact-wrapper");
        if (wrapper) {
          wrapper.innerHTML = `
            <div class="text-center py-5">
              <div class="mb-4">
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="32" cy="32" r="32" fill="#549CE4" fill-opacity="0.1"/>
                  <path d="M44 24L28 40L20 32" stroke="#549CE4" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <h3 class="h3 mb-2">Message Sent!</h3>
              <p class="text-muted">Thank you for reaching out. We'll get back to you shortly.</p>
            </div>
          `;
        }
      }
    });
  }
});
